export function encurtarNome(nome: string = '', max: number = 29) {
    let i = 0, arrNome;
    while (nome.length >= max) {
        arrNome = nome.split(' ');
        let index = arrNome.length - (2 + i);
        if (index === 0) break;

        if (arrNome[index][0] === arrNome[index][0].toUpperCase()) {
            arrNome[index] = arrNome[index][0] + '.';
        }
        nome = arrNome.join(' ');
        i++;
    }

    if (nome.length >= max) {
        arrNome = nome.split(' ');
        for (let j = 0; j < arrNome.length; j++) {
            if (arrNome[j].length <= 2) {
                arrNome[j] = '';
            }
        }
        nome = arrNome.filter(function (x) {
            return x;
        }).join(' ');
    }
    return nome;
}

export function validateCpf(cpf: string) {
    cpf = cpf.replace(/[.-]/g, '');
    let soma;
    let resto;
    soma = 0;
    if (cpf == "00000000000") return false;
    for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if ((resto == 10) || (resto == 11)) resto = 0;
    if (resto != parseInt(cpf.substring(9, 10))) return false;
    soma = 0;
    for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if ((resto == 10) || (resto == 11)) resto = 0;
    return resto == parseInt(cpf.substring(10, 11));
}

export function readableSize(bytes: number) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}